import { useContext } from 'react';

import { NodeInfoDialogContext } from 'contexts/NodeInfoDialog';

const useNodeInfoDialog = () => {
  return useContext(NodeInfoDialogContext);
};

export default useNodeInfoDialog;
